const dictionary = {
    es: {
        messages: {
            required: () => 'Este campo es requerido',
            email: () => `El campo correo debe ser un correo válido.`,
            min: (value, min) => `El campo debe tener un minimo de ${min} letras`,
            confirmed: (value) => `El campo debe ser igual a ${value}`
        }
    }
}

export default dictionary;